import React, { useState } from 'react';
import { generatePortfolioImages } from '../../utils/imageLoader';
import './Portfolio.css';

const PortfolioItem = ({ image, onImageClick }) => {
  return (
    <div className="portfolio-item" onClick={() => onImageClick(image)}>
      <div className="image-container">
        <img 
          src={image.src} 
          alt={image.alt}
          loading="lazy"
        />
      </div>
    </div>
  );
};

const Portfolio = () => {
  // Generamos las imágenes directamente
  const portfolioImages = generatePortfolioImages(34);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="container">
        <div className="portfolio-masonry">
          {portfolioImages.map((image) => (
            <PortfolioItem
              key={image.id}
              image={image}
              onImageClick={openModal}
            />
          ))}
        </div>
        
        {/* <div className="video-section">
          <div className="video-header">
            <div className="video-subtitle">Behind the Lens</div>
          </div>
          <div className="video-container">
            <div className="video-wrapper">
              <iframe
                src="https://player.vimeo.com/video/1090548605?badge=0&autopause=0&player_id=0&app_id=58479&background=0&autoplay=0&loop=0&muted=0&title=0&byline=0&portrait=0&controls=1"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                title="Behind the Lens"
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div> */}
        
        {/* <div className="vogue-section">
          <p className="vogue-text">
            My work has been featured on{' '}
            <a 
              href="https://www.vogue.com/photovogue/photographers/156736" 
              target="_blank" 
              rel="noopener noreferrer"
              className="vogue-link"
            >
              <em>Vogue PhotoVogue</em>
            </a>, showcasing my commitment to artistic excellence and contemporary visual storytelling.
          </p>
        </div> */}
      </div>

      {isModalOpen && selectedImage && (
        <div className={`image-modal ${isModalOpen ? 'modal-open' : ''}`} onClick={closeModal}>
          <div className="modal-backdrop"></div>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal} aria-label="Cerrar">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="modal-image-container">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
